/* Touch preview of secondary product photograph without hijacking normal product navigation. */
(()=>{'use strict';
 const cardSelector='.product-card-wrapper,.gf-five-catalog__card,.g-product';
 let active=null,startX=0,startY=0,swiped=false,ignoreClickUntil=0;
 const matchingCard=el=>{
   if(!(el instanceof Element))return null;
   const card=el.closest(cardSelector);
   if(!card)return null;
   const media=el.closest('.card__media,.gf-five-catalog__media,.g-product__photo');
   if(!media||!card.contains(media))return null;
   if(!card.querySelector('.media--hover-effect>img:nth-of-type(2),.gf-five-catalog__image--secondary,.g-product__second'))return null;
   return card;
 };
 document.addEventListener('touchstart',e=>{
   if(e.touches.length!==1)return;
   const card=matchingCard(e.target);
   if(!card)return;
   if(active&&active!==card)active.classList.remove('gf-touch-preview');
   active=card;swiped=false;
   startX=e.touches[0].clientX; startY=e.touches[0].clientY;
   card.classList.add('gf-touch-preview');
 },{passive:true});
 document.addEventListener('touchmove',e=>{
   if(!active||e.touches.length!==1)return;
   const dx=e.touches[0].clientX-startX,dy=e.touches[0].clientY-startY;
   if(Math.abs(dy)>18&&Math.abs(dy)>Math.abs(dx)*1.25){active.classList.remove('gf-touch-preview');active=null;return}
   if(Math.abs(dx)>22&&Math.abs(dx)>Math.abs(dy)*1.2)swiped=true;
 },{passive:true});
 const end=()=>{
   if(!active)return;
   const old=active;
   if(swiped)ignoreClickUntil=Date.now()+420;
   active=null;
   setTimeout(()=>old.classList.remove('gf-touch-preview'),650);
 };
 document.addEventListener('touchend',end,{passive:true});
 document.addEventListener('touchcancel',end,{passive:true});
 document.addEventListener('click',e=>{
   if(Date.now()>ignoreClickUntil)return;
   if(e.target instanceof Element&&e.target.closest(cardSelector)){e.preventDefault();e.stopPropagation();ignoreClickUntil=0}
 },true);
})();
